import axios from '@/libs/api.request'
var qs = require('qs')

// 获取列表数据
export const fetchTableList = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: 'proxy/proxy-list',
        data,
        method: 'post'
    })
};
// 获取添加修改表单详情
export const fetchInfo = (params) => {
    let data = qs.stringify(params);

    return axios.request({
        url: 'proxy/proxy-info',
        data,
        method: 'post'
    })
};
// 添加和修改
export const addModify = (params) => {
    let data = qs.stringify(params);

    return axios.request({
        url: 'proxy/proxy-add',
        data,
        method: 'post'
    })
};
// 删除
export const setDel = (params) => {
    let data = qs.stringify(params);

    return axios.request({
        url: 'proxy/proxy-delete',
        data,
        method: 'post'
    })
};
// 改变状态
export const setStatus = (params) => {
    let data = qs.stringify(params);
    return axios.request({
        url: 'proxy/proxy-update',
        data,
        method: 'post'
    })
};
// 获取校区列表
export const fetchSchoolList = (params) => {
    let data = qs.stringify(params);

    return axios.request({
        url: 'proxy/proxy-school',
        data,
        method: 'post'
    })
};